import React, { useEffect, useState } from 'react'
import configs from "./configs.js";
import common from '../methods/common.js';

const ClientForm = (props) => {

    const [isPrefilled, setPrefill] = useState(false)
    let {data, updateData, clientFormSubmit, isClientDone}  =props


    useEffect(()=>{
        if(!isPrefilled){
            let u = localStorage.getItem('user');
            if (u) {
                u = JSON.parse(u);
                configs.vacsplFornInputsArr.forEach((field)=>{
                    let val = ""
                    switch(field.key){
                        case "serviceEngineername": val=u.full_name; break;
                        case "serviceEngineerNumber": val=u.contact_number; break;
                        case "serviceEngineerEmail": val=u.email; break;
                        case "dateOfService": val=common.getTodayDate("dd-mm-yyyy"); break;
                        default :val=""
                    }
                    updateData({[field.key]: val});
                    
                })
            }
            setPrefill(true)
        }
    },[isPrefilled, updateData])


    const handleChange=(e)=>{
        let name = e.target.name;
        let value = e.target.value;
        updateData({[name]: value});
    }

    const renderLabelInputs = (obj) => {
        return <div className="labelinput">
            <label>{obj.value} : </label>
            <input required={obj.isRequired} type="text" placeholder={`${obj.value}`} name={`${obj.key}`} value={data[obj.key]} onChange={handleChange}/>
        </div>
    }
    if(isClientDone){
        return <div className='editClient'>
            <button type='button' onClick={()=>clientFormSubmit(false)} className='btn btn-round mr-1 btn button-4 btn-sm'>Edit Company Details</button>
            </div>
    }
    return (
        <div>
            <div className='client-form-main'>
                <div className='client-form'>
                    <form onSubmit={() => clientFormSubmit(true)}>
                        <h2>Client Details:</h2>
                        {configs.clientFornInputsArr.map((item)=>renderLabelInputs(item)) }

                        <h2>Service Engineer Details:</h2>
                        {configs.vacsplFornInputsArr.map((item)=>renderLabelInputs(item)) }
                        <button type='submit' className='btn btn-round mr-1 btn button-4 btn-sm'>Save Details</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ClientForm